import React from 'react';
import { FOCUS_RING } from '../focusRing';

export interface ChatSuggestionProps {
    text: string;
    /** Fills the composer — never sends. A suggestion is a starting point the reader edits,
     *  not a message the component decides to submit on their behalf. */
    onPick: (text: string) => void;
    disabled?: boolean;
    className?: string;
}

const BASE_CLASSES =
    'self-start max-w-full text-left whitespace-normal transition-colors cursor-pointer text-[12px] leading-[1.45] rounded-[var(--malachite-radius-lg,8px)] border border-solid px-2.5 py-[7px] disabled:cursor-not-allowed disabled:opacity-50 disabled:pointer-events-none';

const COLOR_CLASSES =
    'bg-[var(--malachite-assistant-surface-background)] hover:bg-[var(--malachite-tag-assistant-background)] border-[var(--malachite-assistant-surface-border)] text-[var(--malachite-assistant-surface-foreground)]';

/**
 * A tappable example prompt under `Chat.Thread`'s empty state — click fills the composer,
 * it never sends. `onPick` receives its own `text` so a caller wires it with no closure.
 */
const ChatSuggestion: React.FC<ChatSuggestionProps> = ({
    text,
    onPick,
    disabled = false,
    className = '',
}) => (
    <button
        type="button"
        className={`${FOCUS_RING} ${BASE_CLASSES} ${COLOR_CLASSES} ${className}`}
        disabled={disabled}
        onClick={() => onPick(text)}
    >
        {text}
    </button>
);

export default ChatSuggestion;
export { ChatSuggestion };
